module.exports = __webpack_public_path__ + "img/123.3.25f0d299.png";